import React from "react";
import { Formik, Form } from "formik";
import { Box, Typography, Link } from "@mui/material";

import "../login.scss";
import styles from "../login.style";
import useOTPHelper from "./helper";
import { IMAGES } from "../../../common/constants";
import OtpInput from "../../../components/formControls/otpInput";
import ContainedButton from "../../../components/button/contained-button";

export default function Otp() {
  const {
    email,
    timer,
    isLogin,
    cmsLinks,

    formatTime,
    handleResendCode,
    onSubmitOtpHandler,
    handleSupportClick,
    handleSupportBackBtnClick,
  } = useOTPHelper();
  return (
    <>
      {isLogin ? (
        <div className="login-container">
          <div>
            <Box sx={styles.backtologin}>
              <ContainedButton
                title=""
                className="backtologin"
                externalStyles={styles.btnback}
                fullWidth
                size="large"
                type="submit"
                onClick={handleSupportBackBtnClick}
              />
            </Box>
            <h1 className="email-verification">Email Verification</h1>
            <h3 className="code">
              Enter the 6 digits verification code sent to <span>{email}</span>
            </h3>
            <Formik initialValues={{ otp: "" }} onSubmit={onSubmitOtpHandler}>
              {({ values }) => (
                <Form>
                  <Typography variant="h6" component="label" sx={styles.label}>
                    OTP
                  </Typography>
                  <Box sx={styles.otpcontainer}>
                    <OtpInput name="otp" />
                  </Box>
                  {timer !== 0 && (
                    <Typography component="p" sx={styles.resend}>
                      Resend Code in{" "}
                      <Box component="span" sx={{ color: "#FF5F30" }}>
                        {formatTime(timer)}
                      </Box>{" "}
                    </Typography>
                  )}

                  {timer === 0 && (
                    <Box sx={styles.btnwrapperresend}>
                      <Typography component="a" onClick={handleResendCode}>
                        Resend Code
                      </Typography>
                    </Box>
                  )}

                  <Box sx={styles.btnContainer}>
                    <ContainedButton
                      title="Verify"
                      externalStyles={styles.btn}
                      fullWidth
                      size="large"
                      type="submit"
                      disabled={values.otp.length < 6}
                    />
                  </Box>
                  <Box sx={styles.btnwrapper}>
                    <Typography component="a" onClick={handleSupportClick}>
                      Can't Login
                    </Typography>
                  </Box>
                </Form>
              )}
            </Formik>
          </div>
          <Box>
            <div className="cms-link-wrapper wraps">
              <div className="cms_links">
                <Link
                  href={cmsLinks?.privacy_policy}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link"
                >
                  Privacy Policy
                </Link>
                <Link
                  href={cmsLinks?.terms_of_use}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link"
                >
                  Terms of Use
                </Link>
              </div>

              <div className="links privacyChoice login_choice_link">
                <img
                  src={IMAGES.PrivacyChoiceIcon}
                  alt="Privacy Choice Icon"
                  className="privacyIcon"
                />
                <Link
                  href={cmsLinks?.your_privacy_choices}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link"
                >
                  Your Privacy Choices
                </Link>
              </div>
            </div>
          </Box>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
